import { Router } from "@angular/router";
import { DialogService } from "projects/Shared-Lib/component/dialog/dialog.service";
import { BaseeSearchClass, ReturnClass } from "projects/Shared-Lib/model/search-result";
import { DataService } from "projects/Shared-Lib/services/data.service";
import * as t from '../lib/select/select-service';
import { SelectListItem } from "../lib/select/select-property";

const ControllerName: string = 'AuthUser';

export class AuthUser{
  //[Key] - Guid
  UserID?: string;
  UserAccount?: string;
  UserName?: string;
  EMail?: string;
  UserType?: any;
  IsEnabled?: boolean;
  UpdatedBy?: string;
  UpdatedDateTime?: string;
  SelectEnabled?: any;

  constructor() {
  }

  SetData(data: AuthUser) {
    this.UserID = data.UserID;
    this.UserAccount = data.UserAccount;
    this.UserName = data.UserName;
    this.EMail = data.EMail;
    this.UserType = data.UserType;
    this.IsEnabled = data.IsEnabled;
    this.UpdatedBy = data.UpdatedBy;
    this.UpdatedDateTime = data.UpdatedDateTime;
    this.SelectEnabled = data.IsEnabled ? 1 : 0;
  }
}

export class SearchClass extends BaseeSearchClass {
  UserAccount?: string;
  UserName?: string;
}

export class AuthUser_Search {
  filter: SearchClass;
  DataResult?: ReturnClass;

  constructor() {
    this.filter = new SearchClass();
    this.filter.UserAccount = '';
    this.filter.UserName = '';

    this.DataResult = { draw: 1, recordsFiltered: 0, recordsTotal: 0, data: [] };
  }
}

export class AuthUser_Document extends AuthUser {
  ddlIsEnabled?: SelectListItem[];
  SelectEnabled?: any;
  ddlUserType?: SelectListItem[];

  constructor(private dlgService: DialogService, private router: Router, private dataService: DataService) {
    super();
    this.ddlIsEnabled = t.GetItems(t.Items.Options_Enabled);
    this.ddlUserType = [{ value: 1, text: "Internal"},
                        { value: 2, text: "External"}];
  }

  /** Get Document by UserID
  * @param userid : string
  */
  GetDocument(userid: string) {
    this.dataService.getData(`${ControllerName}/${userid}`, null, (ret) => {
      console.log('Document retrieved:', ret);
      this.SetData(ret);
    }, (ret) =>{
      this.dlgService.ErrorInformation(ret.Message);
    });
  }
}